"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTabTitle = updateTabTitle;
exports.requestCloseTabFromSubject = requestCloseTabFromSubject;
exports.userLoggedIn = userLoggedIn;
exports.languageSelected = languageSelected;
exports.localeSelected = localeSelected;
exports.requestOpenTab = requestOpenTab;
exports.tabRemoved = tabRemoved;
exports.tabOpened = tabOpened;
exports.tabActivated = tabActivated;
exports.removeTab = removeTab;
exports.screenAmountProfileSelected = screenAmountProfileSelected;
exports.resetUserSettingsRequested = resetUserSettingsRequested;
exports.error = error;
function updateTabTitle(id, title) {
    return {
        type: "global-actions/UPDATE_TAB_TITLE",
        id: id,
        title: title
    };
}
function requestCloseTabFromSubject(subject) {
    return {
        type: "global-actions/REQUEST_CLOSE_TAB_FROM_SUBJECT",
        payload: subject
    };
}
function userLoggedIn(accessToken) {
    return {
        type: "global-actions/USER_LOGGED_IN",
        accessToken
    };
}
function languageSelected(language) {
    return {
        type: "global-actions/LANGUAGE_SELECTED",
        payload: language
    };
}
function localeSelected(locale) {
    return {
        type: "global-actions/LOCALE_SELECTED",
        payload: locale
    };
}
function requestOpenTab(tabSpec) {
    return {
        type: "global-actions/REQUEST_OPEN_TAB",
        payload: tabSpec
    };
}
function tabRemoved(subject) {
    return {
        type: "main/TAB_REMOVED",
        payload: subject
    };
}
function tabOpened(tabReference) {
    return {
        type: "global-actions/TAB_OPENED",
        payload: tabReference
    };
}
function tabActivated(tab) {
    return {
        type: "global-actions/TAB_ACTIVATED",
        payload: tab
    };
}
function removeTab(tab) {
    return {
        type: "global-actions/TAB_REMOVE_TAB",
        payload: tab
    };
}
function screenAmountProfileSelected(guid) {
    return {
        type: "global-actions/SCREEN_AMOUNT_PROFILE_SELECTED",
        payload: guid
    };
}
function resetUserSettingsRequested() {
    return {
        type: "global-actions/RESET_USER_SETTINGS_REQUESTED"
    };
}
function error(errorInfo) {
    return {
        type: "global-actions/ERROR",
        payload: errorInfo
    };
}
//# sourceMappingURL=actions.js.map